import { MarketRadio, MarketRow } from '@market/react';
import styles from 'typescript/components/option_rows/option_row.module.scss';

export const ROW_DATA_TEST_ID = 'row-data-test-id';
export const RADIO_DATA_TEST_ID = 'radio-data-test-id';

export interface StyledText {
  text: string;
  style: string;
}

interface OptionRowProps {
  title: string;
  subtext: (string | StyledText)[];
  sideLabel: string;
  value: string;
  disabled?: boolean;
  dataTestId?: string;
  selected?: boolean;
  optionKey?: string;
}

const OptionRow = ({
  title,
  subtext,
  sideLabel,
  value,
  disabled = false,
  dataTestId = ROW_DATA_TEST_ID,
  selected = false,
  optionKey = '',
}: OptionRowProps) => {
  // ensure all subtext items are in StyledText form
  const styledSubtext = subtext.map((item) =>
    typeof item === 'string' ? { text: item, style: '' } : item,
  );

  return (
    <MarketRow
      selected={selected}
      data-testid={dataTestId}
      disabled={disabled}
      value={value}
    >
      <label slot="label">{title}</label>
      {styledSubtext.map(({ text, style }, i) => (
        <p
          key={`styled-subtext-${optionKey}-${i}`}
          className={styles[style]}
          slot="subtext"
        >
          {text}
        </p>
      ))}
      <label slot="side-label">{sideLabel}</label>
      <MarketRadio data-testid={RADIO_DATA_TEST_ID} slot="control" />
    </MarketRow>
  );
};

export default OptionRow;
